export default "__VITE_ASSET__CAdWd9Wz__"